<template>
    <div class='time'>
        <!-- <div>{{now_date}}</div> -->
         <div>
             <span class='time_name'>时间</span>
             <span class="date_time">{{year_month}}</span>
        </div>
         <div class='now_time'>
             <span class="bg">{{now_date.H}}</span> :
             <span class='bg'>{{now_date.M}}</span> :
             <span class='bg'>{{now_date.S}}</span>
         </div>
        <div class="sync" @click="handleSync" title="同步数据" v-if="map_type==1?true:false"></div>

    </div>
</template>
<script>
    import {mapState, mapMutations} from 'vuex'
export default {
    data(){
        return{
            now_date: {
                H:'',
                M:'',
                S:''
            },
            year_month:'',

            // 同步数据记录点击次数，默认为0
            i:0,
        }
    },
    mounted(){
        this.init();
    },
    computed:{
        ...mapState(['map_type']),
    },
    methods:{
        init() {
            this.get_date_time();
        },
        // 获取当前时间
        timeFormate(timeStamp) {
        let year = new Date(timeStamp).getFullYear();
        let month =new Date(timeStamp).getMonth() + 1 < 10? "0" + (new Date(timeStamp).getMonth() + 1): new Date(timeStamp).getMonth() + 1;
        let date =new Date(timeStamp).getDate() < 10? "0" + new Date(timeStamp).getDate(): new Date(timeStamp).getDate();
        let hh =new Date(timeStamp).getHours() < 10? "0" + new Date(timeStamp).getHours(): new Date(timeStamp).getHours();
        let mm =new Date(timeStamp).getMinutes() < 10? "0" + new Date(timeStamp).getMinutes(): new Date(timeStamp).getMinutes();
        let ss =new Date(timeStamp).getSeconds() < 10? "0" + new Date(timeStamp).getSeconds(): new Date(timeStamp).getSeconds();
        this.year_month = year + "-" + month + "-" + date;
        this.now_date = {
            H:hh,
            M:mm,
            S:ss
        }
        },
        // 定时器函数
        get_date_time(){
        this.timeFormate(new Date());
            setTimeout(this.get_date_time,1000);
        },
        handleSync(){
            var count = this.i;
            count ++;
            this.i = count;
            console.log(count,'count');
            if(count<=1){
                //刷新接口
                this.$bus.$emit('map_init_bus');
            } else {
                this.$message({
                    showClose: true,
                    message: '系统已同步到最新数据',
                    type: 'warning'
                })
            }

        }
    }
}
</script>

<style lang="less" scoped>
// @font-face{
//   font-family: hzgb;
//   src: url('.././../assets/font/hzgb.ttf');
// }
.sync{
    width: 20px;
    height: 20px;
    background: url(../../../static/img/two.png) no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: 48px;
    right: 5px;
    z-index: 10;
    cursor: pointer;
}
.time{
    font-family: dateTime;
    font-size: 30px;
    color: #0bdef3;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    padding-top: 30px;
    margin-left: 80px;
    position: absolute;
    z-index: 9;
    .time_name{
        font-size: 16px;
        color: #ffc602;
    }
    .date_time{
        font-family: dateTime;
        font-size: 16px;
        color: #0bddf6;
    }
    .now_time{
        .bg{
            font-family: dateTime;
            background: #2a2b57;
            text-align: center;
            padding: 2px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/page/main_content/time.vue